import { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import CouponForm from '../../../checkout/CouponForm'
import PriceConverter from '../../../helpers/PriceConverter'

const BookingDetailsCardFooter = ({
  order,
  selectedCurrency,
  showCouponForm,
  onVoucherAdd,
}) => {
  const { currency, amountTotal, currencyToCharge } = order
  const isUserCurrency = currency === selectedCurrency
  const otherCurrencyToCharge =
    currency !== currencyToCharge || currency !== selectedCurrency
  return (
    <Fragment>
      <div className='price-pan total'>
        <ul>
          <li>
            <FormattedMessage
              tagName='strong'
              id='total_price'
              defaultMessage='Total price'
            />
            <strong className='large'>
              <small>{selectedCurrency}&nbsp;</small>
              <PriceConverter
                decimals={0}
                noCurrency
                amount={amountTotal}
                currency={currency}
              />
              {otherCurrencyToCharge && <sup className='asterisk'>*</sup>}
            </strong>
          </li>
          {!isUserCurrency && (
            <li>
              <FormattedMessage
                tagName='small'
                id='in_resort_currency'
                defaultMessage="in the operator's currency"
              />
              <span>
                <small>{currency}</small> {amountTotal}
              </span>
            </li>
          )}
          <li>
            <small className='price-information'>
              <FormattedMessage
                id='booking_details.price_includes_taxes'
                defaultMessage='Prices include taxes & service fees'
              />
            </small>
          </li>
        </ul>
      </div>
      {otherCurrencyToCharge && (
        <p className='footnote'>
          <sup>*</sup>
          {currency !== selectedCurrency ? (
            <FormattedMessage
              id='checkout.last.step.price_hint1'
              values={{
                currency: currencyToCharge,
              }}
              defaultMessage='This conversion is an approximate price based on the current exchange rate and may change before your stay. You will have to pay in {currency}'
            />
          ) : (
            <FormattedMessage
              id='checkout.last.step.price_hint2'
              values={{
                currency: currencyToCharge,
              }}
              defaultMessage='You will pay in {currency}. The exact amount in your currency will depend on the exchange rate and potential transaction fees applied by your bank or card provider.'
            />
          )}
        </p>
      )}
      {showCouponForm && <CouponForm onSuccess={onVoucherAdd} />}
    </Fragment>
  )
}

export default connect(({ selectedCurrency }) => ({
  selectedCurrency,
}))(BookingDetailsCardFooter)
